import React, { Component } from "react";
import { MapContainer, TileLayer } from "react-leaflet";

import LocateControl from './locate.componnets';

export default class MapExample extends Component {
  
  render() {
    const locateOptions = {
      position: 'topright',
      strings: {
          title: 'Show me where I am, yo!'
      },
      onActivate: () => {} // callback before engine starts retrieving locations
  }


    return (
      <MapContainer center={this.props.center} zoom={this.props.zoom} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
         <LocateControl options={locateOptions} startDirectly/>
      </MapContainer>
    );
  }
}